import { jsx as _jsx } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { useEffect } from 'react';
import Url from 'urlinator/Url';

const InternalLoginCookies = props => {
  useEffect(() => {
    const {
      search
    } = props.location;
    const {
      token,
      redirect
    } = parseQuery(search.substring(1));
    let toolsLogin = new Url('/login/okta', {
      lb: 'tools'
    });

    if (redirect) {
      toolsLogin.pushParam('redirect', encodeURIComponent(redirect));
    }

    const oktaLogin = new Url('/internal-login/v1/login/legacy/okta', {
      lb: 'app'
    }).href;
    noAuthApiClient.post(oktaLogin, {
      data: {
        token
      }
    }).catch(e => {
      console.error(e);
      toolsLogin = new Url('/login/okta', {
        lb: 'tools'
      });
      toolsLogin.pushParam('error', 'true');
    }).then(() => {
      setTimeout(() => {
        window.location.href = toolsLogin.href;
      }, 500);
    }).catch(console.error); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "INTERNAL_LOGIN_APP_COOKIE_LOAD",
    children: /*#__PURE__*/_jsx("div", {
      className: "auto-login text-center",
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "okta-loading",
        children: /*#__PURE__*/_jsx(UILoadingDots, {
          minHeight: 100
        })
      })
    })
  });
};

export default InternalLoginCookies;